export const AUTH_STATES = {
    AUTHENTICATED: 'AUTHENTICATED',
    CONFIRM_SIGN_UP_REQUIRED: 'CONFIRM_SIGN_UP_REQUIRED',
    NEW_PASSWORD_REQUIRED: 'NEW_PASSWORD_REQUIRED',
    PASSWORD_RESET_REQUIRED: 'PASSWORD_RESET_REQUIRED',
};

export const getAuthStateForSignInStep = (signInStep) =>
    ({
        DONE: AUTH_STATES.AUTHENTICATED,
        CONFIRM_SIGN_UP: AUTH_STATES.CONFIRM_SIGN_UP_REQUIRED,
        CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED: AUTH_STATES.NEW_PASSWORD_REQUIRED,
        RESET_PASSWORD: AUTH_STATES.PASSWORD_RESET_REQUIRED,
    })[signInStep] || null;
